import React from 'react'
import type { SearchClient } from 'algoliasearch/lite'
import { OfferListHero } from './OfferListHero'
import { SearchRefinementClear } from '../../../search'
import { formatContractType } from '../../../offers/format'
import { RefinementListProps } from '../../../search/refinementList'

export interface SearchSectionProps {
  searchClient: SearchClient
  googleMapsApiKey: string
}

const refinementAttributes: RefinementListProps[] = [
  {
    attribute: 'jobType',
    name: 'Type',
    type: 'list',
    searchable: true,
  },
  {
    attribute: 'contractType',
    name: 'Contrat',
    type: 'list',
    transformLabel: formatContractType,
  },
  {
    attribute: 'educationRequirement',
    name: 'Formation',
    type: 'list',
  },
  {
    attribute: 'experienceRequirement',
    name: 'Niveau',
    type: 'list',
  },
  {
    attribute: 'tools',
    name: 'Logiciel',
    type: 'list',
    searchable: true,
  },
  {
    attribute: 'payRange.min',
    name: 'Salaire',
    type: 'range',
    transformLabel: (value: string) => `${parseInt(value, 10) + 1}k€/an`,
    searchable: true,
  },
]

export const SearchSection = ({
  searchClient,
  googleMapsApiKey,
}: SearchSectionProps) => (
  <>
    <OfferListHero
      searchClient={searchClient}
      googleMapsApiKey={googleMapsApiKey}
      refinementAttributes={refinementAttributes}
    />
    <div className="z-10 pb-3 border-b border-gray-300 lg:self-center">
      <SearchRefinementClear attributes={[...refinementAttributes]} />
    </div>
  </>
)
